'use client';
import Link from 'next/link';
import {useEffect, useState} from 'react';
import {target} from '../helpers/utils';

export default function Url({
  children,
  href,
  ...props
}: React.PropsWithChildren<{href: string}> &
  React.HTMLAttributes<HTMLAnchorElement>) {
  const [herfLink, setHrefLink] = useState(href);
  useEffect(() => {
    // add mark for internal link
    if (!href.startsWith('http') && !href.startsWith('/uploads')) {
      // split hash
      const [url, hash] = href.split('#');
      setHrefLink(
        url +
          (url.includes('?') ? '&' : '?') +
          'referrer=' +
          window?.location.pathname +
          (hash ? '#' + hash : '')
      );
    }
  }, [href]);

  if (!href || href == '#') {
    return <span {...props}>{children}</span>;
  }

  if (href.includes('#')) {
    return (
      <a href={herfLink} {...props} target={target(href)}>
        {children}
      </a>
    );
  }
  return (
    <Link href={herfLink} {...props} target={target(href)} prefetch={false}>
      {children}
    </Link>
  );
}
